import type { GraphQLError } from "graphql";

export type ErrorValueType = GraphQLError[] | undefined | string[];

export const hasGraphQLErrors = (...errors: ErrorValueType[]): boolean => {
    return errors.some((error) => Array.isArray(error) && error.length > 0);
};
